import { createFileRoute } from "@tanstack/react-router";
import { EventDetailScreen } from "../screens/EventDetailScreen";

export const Route = createFileRoute("/events/$eventId")({
  component: EventDetail,
});

function EventDetail() {
  const { eventId } = Route.useParams();
  // Deliberately not cast to Id<"events">: it is whatever was in the URL. The
  // query decides whether it names a real event and says so by returning null.
  return <EventDetailScreen eventId={eventId} />;
}
